import React from 'react';
import { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Environment } from '@react-three/drei';
import clarensHdr from 'assets/clarens_midday_1k.hdr';
import Scene from "./scene";
import LoaderProgress from './loader_progress';
import { ErrorBoundary } from 'react-error-boundary';
import ModelLoadError from './model_load_error';
import ProductDescription from './product_description';

const ThreeView = ({ filters, sortedProducts }) => {

    return (
        <>
          <Canvas
            frameloop="demand"
            shadows
            camera={{ position: [4, 6, -12], fov: 35 }}
            style={{ height: '1000px' }}
          >
            <Suspense fallback={<LoaderProgress />}>
              <directionalLight color="white" position={[2, 6, 3]} intensity={6}/>
              <directionalLight color="white" position={[-10, 6, -10]} intensity={5}/>
              <ambientLight color="white" intensity={0.8}/>
              <ErrorBoundary fallback={<ModelLoadError />}>
                <Scene filters={filters} sortedProducts={sortedProducts}/>
              </ErrorBoundary>
              <Environment files={clarensHdr} blur={0.5} />
              <OrbitControls
                enableDamping={false}
              />
            </Suspense>
          </Canvas>
          <ProductDescription sortedProducts={sortedProducts} />
        </>
      );
    };
    
export default ThreeView;